import { useEffect, useState } from 'react';
import { getWidth } from '../helpers/getWidth';
import { useEditCharter } from './useEditCharter';

export const useResize = (activeTab, item) => {
    let width = getWidth(Number(item?.planned.days_count), activeTab);

    const [elWidth, setElWidth] = useState(width);
    const [needResizeUpdate, setNeedResizeUpdate] = useState(false);

    const { increaseCharter, decreaseCharter } = useEditCharter(item);

    const changeWidth = (movementX) => {
        setElWidth((prevState) => {
            return prevState + movementX;
        });
    };

    const onItemChange = () => {
        setNeedResizeUpdate(true);
    };

    useEffect(() => {
        if (needResizeUpdate) {
            let days_count = Math.round(elWidth / 24 + 1);

            if (activeTab === 'week') {
                days_count = Math.round((elWidth + 23) / 11);
            }

            if (activeTab === 'month') {
                days_count = Math.round((elWidth + 23) / 7);
            }

            days_count = days_count < 1 ? 1 : days_count;

            const startDate = item.planned.start_date;

            if (+item.planned.days_count !== days_count) {
                const difference = +item.planned.days_count - days_count;

                const isDecrease = +item.planned.days_count > days_count;

                if (!isDecrease) {
                    increaseCharter(item, { days: `${days_count}`, date: startDate });
                } else {
                    decreaseCharter(item, difference);
                }
            }

            setElWidth(width);

            setNeedResizeUpdate(false);
        }
    }, [needResizeUpdate]);

    useEffect(() => {
        setElWidth(width);
    }, [item]);
    return {
        elWidth,
        needResizeUpdate,
        setNeedResizeUpdate,
        setElWidth,
        changeWidth,
        onItemChange,
    };
};
